import {useSearchParams} from 'react-router-dom';

import {paymentAPI} from 'entities/payment';

export const usePaymentFromQuery = () => {
    const [searchParams] = useSearchParams();
    const id = Number(searchParams.get('InvId'));

    const {data, isLoading, isFetching} = paymentAPI.useGetPaymentQuery(id, {skip: !id});

    return {
        payment: data,
        isLoading: isLoading || isFetching,
        isNotFound: !id || (!data && !isLoading && !isFetching),
    };
};

export default usePaymentFromQuery;
